(function() {
  var Service,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.UserSelectionService = (function(superClass) {
    extend(UserSelectionService, superClass);

    function UserSelectionService(rootScope) {
      this.rootScope = rootScope;
      this.options = {
        selected_year: null,
        selected_field: null
      };
      this.layer = null;
    }

    UserSelectionService.prototype.getOptions = function() {
      return this.options;
    };

    UserSelectionService.prototype.getYear = function() {
      return this.options.selected_year;
    };

    UserSelectionService.prototype.getField = function() {
      return this.options.selected_field;
    };

    UserSelectionService.prototype.getLayer = function() {
      return this.layer;
    };

    UserSelectionService.prototype.setOptions = function(params) {
      return this.options = {
        selected_year: params.year,
        selected_field: params.field
      };
    };

    UserSelectionService.prototype.setLayer = function(param) {
      return this.layer = param;
    };

    UserSelectionService.prototype.setYear = function(year) {
      return this.options.selected_year = year;
    };

    UserSelectionService.prototype.setField = function(field) {
      return this.options.selected_field = field;
    };

    return UserSelectionService;

  })(Service);

}).call(this);
